const BITBUCKET_STAGE_URL = "https://integration.bb-inf.net";
const BITBUCKET_PROD_URL = "https://bitbucket.org";
const BITBUCKET_IDENTITY_STAGE_URL = "https://id.stg.internal.atlassian.com";
const BITBUCKET_IDENTITY_PROD_URL = "https://id.atlassian.com";

export function generateBitbucketWorkspaceURL(
    isProduction: boolean,
    workspaceUuid: string
): string {
    const reformattedWorkspaceUuid = encodeURIComponent(`{${workspaceUuid}}`);
    const reformattedWorkspacePath = encodeURIComponent(
        `/${reformattedWorkspaceUuid}/workspace/overview/`
    );
    const BB_URL = isProduction ? BITBUCKET_PROD_URL : BITBUCKET_STAGE_URL;
    const BB_IDENTITY_BASE_URL = isProduction
        ? BITBUCKET_IDENTITY_PROD_URL
        : BITBUCKET_IDENTITY_STAGE_URL;
    const BB_IDENTITY_URL = `${BB_IDENTITY_BASE_URL}/login?application=bitbucket&continue=`;
    return `${BB_IDENTITY_URL}${BB_URL}/account/signin?next=${reformattedWorkspacePath}`;
}
